import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let CharacterAdvancements = class CharacterAdvancements extends VuexModule {
    constructor() {
        super(...arguments);
        this.characterAdvancements = [];
        this.cachedVersion = 0;
    }
    async fetchCharacterAdvancements() {
        const { data: characterAdvancements, cachedVersion } = await fetchFromCache(this, 'characterAdvancements', 'characterAdvancement', 'characterAdvancementLU');
        return { characterAdvancements, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['characterAdvancements', 'cachedVersion'] })
], CharacterAdvancements.prototype, "fetchCharacterAdvancements", null);
CharacterAdvancements = __decorate([
    Module({ namespaced: true, name: 'characterAdvancements' })
], CharacterAdvancements);
export default CharacterAdvancements;
